import gql from "graphql-tag";
import { ACCOUNT_BANKING_FRAGMENT } from "./fragment";

export const ON_BALANCE_UPDATE = gql`
  subscription OnBalanceUpdate($clientId: Int) {
    onBalanceUpdate(clientId: $clientId) {
      ...AccountBankingInfo
    }
  }
  ${ACCOUNT_BANKING_FRAGMENT}
`;
